import { TIME_UNITS } from '../constants/time-unit.constant';

/**
 * Converts time value to specified target unit
 */
export function convertTimeUnit(value: number, fromUnit: string, toUnit: string): number {
    if (!value || fromUnit === toUnit) return value;

    const fromTimeUnit = TIME_UNITS.find(u => u.value === fromUnit);
    const toTimeUnit = TIME_UNITS.find(u => u.value === toUnit);

    if (!fromTimeUnit || !toTimeUnit) return value;

    /**
     *  Convert to seconds first, then to target unit 
     */
    const result = value * fromTimeUnit.toSeconds / toTimeUnit.toSeconds;

    return result;
  }

  /**
 * Converts time value to seconds based on unit
 */
export function convertToSeconds(value: number, unit: string): number {
    return convertTimeUnit(value, unit, 'seconds');
  }

  /**
 * Converts time value to milliseconds based on unit
 */
export function convertToMilliseconds(value: number, unit: string): number {
    return convertTimeUnit(value, unit, 'milliseconds');
  }

  /**
   * Converts time value to minutes based on unit
   */
  export function convertToMinutes(value: number, unit: string): number {
    return convertTimeUnit(value, unit, 'minutes');
  }

  /**
   * Converts time value to hours based on unit
   */
  export function convertToHours(value: number, unit: string): number {
    return convertTimeUnit(value, unit, 'hours');
  }
